import { DATA_TESTID, Text_INTERNAL } from "../Text_INTERNAL";
import type { TextInternalProps } from "../Text_INTERNAL";

export const FONT_WEIGHTS = ["medium", "semibold"];

const styleProps = {
  size: "text-xs",
  leading: "leading-4",
};

export interface LabelXsProps extends TextInternalProps {
  "data-testid"?: string;
}

export const LabelXs = ({
  weight = "normal",
  color,
  textTransform,
  truncate,
  as = "span",
  [DATA_TESTID]: dataTestId,
  children,
}: LabelXsProps) => {
  const props = {
    ...styleProps,
    dataTestId,
    weight: `font-${weight}`,
    color,
    textTransform,
    truncate,
  };

  return (
    <Text_INTERNAL as={as} {...props}>
      {children}
    </Text_INTERNAL>
  );
};
